import { TimelineMax } from "gsap";
import { IDimConfig, ResizeHelper } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { SplashView } from "../SplashController"
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { SanGameConfig } from "../../../../SanGameConfig";
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { TranslationConfig } from "../../../../translation/TranslationConfig";
import { TextStyleConfig } from "../../../../translation/TextStyleConfig";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { SplashViewResultData } from "./SplashViewResult"
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { SpinePlayer } from "../../../../proto/SpinePlayer";
import { SanJumpData } from "../../../../server/data/ISanServerData";

export interface totalPresentationJWFS{
    jwData:SanJumpData[];
    fs:number;
}

export class SplashTotalWin extends BaseView implements SplashView  {

    protected layoutDim: IDimConfig = {
        dimOrientation: {
            landscape: {
                scale: new PIXI.Point(0.6, 0.6),
                position: new PIXI.Point(360, 355),
                layout: {
                    left: new PIXI.Point(360, 355),
                    right: new PIXI.Point(360, 355)
                }
            },
            portrait: {
                scale: new PIXI.Point(0.65, 0.65),
                position: new PIXI.Point(360, 380)
            }
        },
        WIDTH: 240,
        HEIGHT: 64,
    };

    private _txt_FS:PIXI.Text;

    private seqs:Sequence[] = [];
    private spines:SpinePlayer[] = [];

    protected _timeLine:TimelineMax;
    protected DEFAULT_TXT_STYLE:TextStyleOptions;

    private lastJwData:SanJumpData[] = [];

    constructor(textStyle:TextStyleOptions){
        super();
        this.DEFAULT_TXT_STYLE = textStyle;
        this.visible = false;
    }
    
    parseResult(data:totalPresentationJWFS){
        this.lastJwData = data.jwData;

        this.seqs.forEach(s => s.visible = false);
        this.spines.forEach(s => s.visible = false);

        for(let i = 0; i < this.seqs.length; i++){
            if(this.lastJwData[i]){
                if((this.lastJwData[i].to.multiplier != undefined && this.lastJwData[i].to.multiplier! > 1)){
                    this.spines[i].visible = true;
                }else{
                    this.seqs[i].setTexture(GameResources.getTextures("Jumping_Wild/JW_4_Badge"));
                    this.seqs[i].visible = true;
                }
            }else{
                this.seqs[i].setTexture(GameResources.getTextures("Jumping_Wild/JW_4_Badge_Dead"));
                this.seqs[i].visible = true;
            }
        }
        this._txt_FS.text = Translation.translate(TranslationConfig.FREESPINS_PLAYED) + " " + data.fs;
    }

    protected initAnimations():void{
        
        for(let i = 0; i < 3; i++){
            this.seqs.push(this.addChild(Sequence.createSequence()));
            this.spines.push(this.addChild(new SpinePlayer("JW_Multi")));
        }

        this.seqs = this.seqs.reverse();
        this.spines = this.spines.reverse();

        for(let i = 0; i < this.seqs.length; i++){
            this.seqs[i].x = -160 +(165 * i);
            this.seqs[i].y = 125;
            this.seqs[i].alpha = 1;
            this.seqs[i].scale.set(1.25,1.25);
            this.spines[i].position = this.seqs[i].position;
            this.spines[i].scale.set(1.25,1.25);
        }

        this._txt_FS = this.createText(Translation.translate(TranslationConfig.COLLECTED_JUMPING_WILDS));
        this._txt_FS.style = TextStyleConfig.COLLECT_TEXT;

        StageManager.getLayer(SanGameConfig.instance.LAYERS.POSTER.name).addChild(this);
    }

    private createText(val: string): PIXI.Text {
        const temp: PIXI.Text = new PIXI.Text(Translation.translate(val));
        temp.style = this.DEFAULT_TXT_STYLE;
        temp.anchor.set(0.5, 0.5);
        this.addChild(temp);
        return temp;
    }
   
    public play():TimelineMax{
        this.visible = true;
        this._timeLine = Helper.timeLineKiller(this._timeLine, new TimelineMax());

        for(let i = 0; i < this.spines.length; i++){
            if(this.spines[i].visible){
                this.spines[i].play({name:"X" + this.lastJwData[i].to.multiplier! + "_End",loop:true});
                // this.spines[i].play({name:"X"+this.lastJwData[i].to.multiplier!}).eventCallback("onComplete",() => this.spines[i].play({name:"X" + this.lastJwData[i].to.multiplier! + "_End",loop:true}));
            }
        }

        this._timeLine.fromTo(this,0.35,{alpha:0},{alpha:1});
        return this._timeLine;
    }

    public stop():TimelineMax{
        this._timeLine = Helper.timeLineKiller(this._timeLine, new TimelineMax({onComplete:() => {
            this.visible = false;
            this.spines.forEach(spine => spine.stop());
        }
        }));
        this._timeLine.to(this,0.35,{alpha:0});
        return this._timeLine;
    }

    public onResize():void{

        this._txt_FS.y = ResizeHelper.IsLandscape() ? 0 : -25;

        this.position = ResizeHelper.calcDim(this.layoutDim).position;
        this.scale = ResizeHelper.calcDim(this.layoutDim).scale;
        if(this._timeLine && this._timeLine.isActive()) this._timeLine.progress(1);

    }
}
